const defaultState = [];

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_TAX_RULES':
      return action.taxRules;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/taxRules.js